import { render } from "./SettingsProjectDialog.vue?vue&type=template&id=137d6b73"
import script from "./SettingsProjectDialog.vue?vue&type=script&lang=js"
export * from "./SettingsProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__